var collapsible_list_pair_default = {
  "container": "_3VuhX",
  "title": "H04LA",
  "viewerContainer": "hjNWU",
  "titleContainer": "pUSSg",
  "expandIcon": "SB6R0",
  "dndIcon": "_0HOre",
  "RTL": "rVYf5",
  "LTR": "nesN9",
  "itemContainer": "EX2zD",
  "itemContainerViewer": "_6CZVJ",
  "mouseDown": "VjTje",
  "innerEditor": "XA74d",
  "item": "_9p62k",
  "floatingAddPluginMenuWrapper": "gqBr6",
  "childrenHidden": "H6lat"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
